export class BasicDepartmentInformation {
    public id: string;
    public name: string | null = '';

    constructor();
    constructor(departmentId: string, departmentName: string | null);
    constructor(departmentId?: string, departmentName?: string | null) {
        if (departmentId !== undefined) {
            this.id = departmentId;
            this.name = departmentName;
        }
    }
}